<template>
    <div :class="[
        'single-collection-path',
    {   'last': isLastItem,
        'halfWatched': isCourseHalfWatched,
        'completed': isCourseCompleted,
        'not-logged': !isLoggedIn }
    ]">
        <span class="single-collection-path__circle"> {{ index + 1 }}</span>
    </div>
</template>

<script>
    export default {
        props: {
            progress: Number,
            index: Number,
            length: Number,
            courseId: Number,
            isCourseCompleted: Boolean,
            isCourseHalfWatched: Boolean,
            isLoggedIn: Boolean
        },
        computed: {
            isLastItem () {
                return this.length === (this.index + 1)
            }
        }
    }
</script>

<style lang="scss" scoped>
    .single-collection-path {
        position: absolute;
        top: 40%;

        &:before {
            content: '';
            position: absolute;
            top: 30px;
            right: 30px;
            height: 100px;
            bottom: 0;
            width: 8px;
            background: $silver_chalice;
            z-index: -1;

            [class*="desktop"] & {
                left: -122.9%;
                height: 285px;
            }
        }

        &.halfWatched {
            .single-collection-path__circle {
                background: $porsche;
            }
        }

        &.mobile {
            left: 8px;
            top: 8px;
            border: none;
            z-index: 1;
            &:before {
                display: none;
            }
        }

        &.not-logged {
            .single-collection-path__circle {
                background: $alto;
            }
        }

        &.completed {
            .single-collection-path__circle {
                background: $silver_tree;
            }
        }

        &.last:before {
            height: 0;
        }

        &__circle {
            width: 40px;
            height: 40px;
            background: $silver_chalice;
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 1.7rem;
            color: $black;
            font-family: Nunito-ExtraBold, sans-serif;
            position: relative;
            z-index: 1;
            margin: 0 20px 0px 0px;

            &.completed {
                background: $de_york;
            }

            &.in-progress {
                background: $porsche;
            }

            [class*="desktop"] & {
                right: 90px;
            }

            [class*="mobile"] & {
                height: 25px;
                width: 25px;
                font-size: 1.2rem;
                font-family: Nunito-ExtraBold, sans-serif;
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }
    }
</style>
